import $api from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import {
  AnnouncementExtended,
  CreateAnnouncement,
} from "@/core/services/api/interfaces/manager/Announcement";

class AnnouncementEndpoint {
  public list(params: AxiosRequestConfig = {}) {
    return $api.get("a/announcements", params);
  }
  public view(id: string | number) {
    return $api.get(`a/announcements/${id}`);
  }
  public create(item: CreateAnnouncement) {
    return $api.post(`a/announcements`, item);
  }
  public update(item: AnnouncementExtended) {
    return $api.put(`a/announcements/${item.id}`, item);
  }
  public delete(item: AnnouncementExtended) {
    return $api.delete(`a/announcements/${item.id}`);
  }
}

export default AnnouncementEndpoint;
